import React, { useState } from 'react';
import Header from '../../../components/MainComponents/Header';

import Footer from '../../../components/MainComponents/Footer';
import { bannerServiceImage, bannerSpecImage } from '../../../config';
import ServiceBanner from '../../../components/ServiceComponents/ServiceBanner';

const NewPatientForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    phone: '',
    date: '',
    service: '',
    diagnosis: '',
    treatmentAims: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form data submitted:', formData);
  };

  return (
    <div>
     <Header/>
     {/* <ServiceBanner image={bannerServiceImage} title={"New Patient Form"} /> */}
     <section className="container mx-auto py-16 px-6 flex flex-col lg:flex-row items-center">
        <div className="lg:w-1/2 w-full mb-12 lg:mb-0 lg:pr-10">
          <form onSubmit={handleSubmit} className="space-y-8 bg-white p-10 rounded-3xl shadow-2xl relative z-10">
            {/* Name */}
            <div className="relative">
              <label htmlFor="name" className="block text-xl font-semibold text-primary mb-2">Full Name</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                value={formData.name}
                onChange={handleChange}
                className="w-full px-6 py-4 border-2 border-gray-200 rounded-full focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-lg" 
                placeholder="Enter your full name" 
              />
            </div>
            
            {/* Address */}
            <div className="relative">
              <label htmlFor="address" className="block text-xl font-semibold text-primary mb-2">Address</label>
              <input 
                type="text" 
                id="address" 
                name="address" 
                value={formData.address}
                onChange={handleChange}
                className="w-full px-6 py-4 border-2 border-gray-200 rounded-full focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-lg" 
                placeholder="Enter your address" 
              />
            </div>
            
            {/* Phone */}
            <div className="relative">
              <label htmlFor="phone" className="block text-xl font-semibold text-primary mb-2">Phone</label>
              <input 
                type="tel" 
                id="phone" 
                name="phone" 
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-6 py-4 border-2 border-gray-200 rounded-full focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-lg" 
                placeholder="Enter your phone number" 
              />
            </div>

            {/* Date */}
            <div className="relative">
              <label htmlFor="date" className="block text-xl font-semibold text-primary mb-2">Date</label>
              <input 
                type="date" 
                id="date" 
                name="date" 
                value={formData.date}
                onChange={handleChange}
                className="w-full px-6 py-4 border-2 border-gray-200 rounded-full focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-lg" 
              />
            </div>
            
            {/* Service List */}
            <div className="relative">
              <label htmlFor="service" className="block text-xl font-semibold text-primary mb-2">Select a Service</label>
              <select 
                id="service" 
                name="service" 
                value={formData.service} 
                onChange={handleChange} 
                className="w-full px-6 py-4 border-2 border-gray-200 rounded-full focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-lg"
              >
                <option value="">Choose a service...</option>
                <option value="Physiotherapy">Physiotherapy (OHIP only in Simcoe)</option>
                <option value="Chiropractic">Chiropractic</option>
                <option value="Massage Therapy">Massage Therapy</option>
                <option value="Shockwave Therapy">Shockwave Therapy</option>
                <option value="Class 4 Deep Tissue Laser">Class 4 Deep Tissue Laser</option>
                <option value="Spinal Decompression">Spinal Decompression</option>
                <option value="Acupuncture">Acupuncture</option>
                <option value="Post Op Rehab">Post Op Rehab</option>
                <option value="Sports Injuries">Sports Injuries</option>
                <option value="Vestibular Rehab (Vertigo)">Vestibular Rehab (Vertigo)</option>
                <option value="MVA and WSIB">MVA and WSIB</option>
              </select>
            </div>
            
            {/* Diagnosis */}
            <div className="relative">
              <label htmlFor="diagnosis" className="block text-xl font-semibold text-primary mb-2">Diagnosis</label>
              <textarea 
                id="diagnosis" 
                name="diagnosis" 
                value={formData.diagnosis} 
                onChange={handleChange} 
                rows="3" 
                className="w-full px-6 py-4 border-2 border-gray-200 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-lg" 
                placeholder="Enter your diagnosis..."
              ></textarea>
            </div>
            
            {/* Aims of Treatment */}
            <div className="relative">
              <label htmlFor="treatmentAims" className="block text-xl font-semibold text-primary mb-2">Aims of Treatment</label>
              <textarea 
                id="treatmentAims" 
                name="treatmentAims" 
                value={formData.treatmentAims} 
                onChange={handleChange} 
                rows="3" 
                className="w-full px-6 py-4 border-2 border-gray-200 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-lg" 
                placeholder="Enter your aims of treatment..."
              ></textarea>
            </div>

            {/* Submit Button */}
            <div className="text-center">
              <button 
                type="submit" 
                className="w-full bg-gradient-to-r from-primary to-secondary text-white py-4 px-10 rounded-full font-semibold shadow-xl hover:scale-105 transition-transform duration-200"
              >
                Submit Form
              </button>
            </div>
          </form>
        </div>

        {/* Image Section */}
        <div className="lg:w-1/2 w-full flex justify-center items-center">
          <div className="relative w-[80%] h-auto rounded-3xl shadow-2xl overflow-hidden">
            {/* <img
              src={bannerSpecImage}
              alt="Physiotherapy"
              className="w-full h-full object-cover transform hover:scale-105 transition duration-500 ease-in-out"
            /> */}
            <div className="absolute inset-0 bg-black opacity-50"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white z-10 px-10">
              <h2 className="text-4xl font-bold mb-4 transform transition duration-300 ease-in-out hover:scale-110">
                Start Your Journey
              </h2>
              <p className="text-xl mb-6 transform transition duration-300 ease-in-out hover:text-gray-300">
                Fill out the form and begin your path to recovery.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default NewPatientForm;
